// One Google Maps JS loader for every RMS surface that draws a map or
// suggests an address: the address editor, the address filter clause, the
// map view and the record page's address map. `useJsApiLoader` dedupes by
// `id` and throws when two call sites ask for the same id with different
// options, so the id, the key and the libraries live here once.

// Browser-side Google Maps API key (project: fin-pilot-383622). Restricted by
// HTTP referrer to our domains and to the Maps JS + Places APIs.
export const GOOGLE_MAPS_BROWSER_API_KEY =
  "AIzaSyDppcBGXlGlFK0GXZ9tLcLng6XEVx-13Pg";

export const GOOGLE_MAPS_LIBRARIES: "places"[] = ["places"];

export const GOOGLE_MAPS_SCRIPT_ID = "google-map-script";

// The one address map (#13870): the editor and the record page draw the same
// map, so its options and starting zoom live here once and cannot drift.
// Gestures are cooperative: the record page scrolls an inner element, not the
// window, so Google's "auto" resolves to greedy there and a plain wheel over
// the map zoomed it instead of scrolling the page. Cooperative keeps plain
// scrolling on the page and zooms on ctrl+scroll.
// The +/- zoom control is off: on the Overview's Key facts rail the map is
// 140px tall and the control covered a large share of it. Zoom stays on
// ctrl+scroll, pinch, double-click and the keyboard's +/- when the map has
// focus.
export const ADDRESS_MAP_OPTIONS: google.maps.MapOptions = {
  disableDefaultUI: true,
  zoomControl: false,
  gestureHandling: "cooperative",
};

export const ADDRESS_MAP_ZOOM = 15;
